<template>
  <article class="chart-card">
    <!-- A collapsible card's header is its toggle; folded, only the header shows. -->
    <component
      :is="collapsible ? 'button' : 'div'"
      :type="collapsible ? 'button' : undefined"
      :aria-expanded="collapsible ? String(open) : undefined"
      class="chart-head flex items-end justify-between gap-3"
      :class="{ 'mb-4': open, 'chart-head--toggle': collapsible }"
      @click="collapsible && (open = !open)"
    >
      <div class="min-w-0">
        <p v-if="title" class="chart-title">{{ title }}</p>
        <p v-if="note" class="chart-note">{{ note }}</p>
      </div>
      <span class="flex flex-none items-center gap-2">
        <span v-if="sample != null" class="sample-pill">n={{ sample }}</span>
        <span v-else-if="pill" class="sample-pill">{{ pill }}</span>
        <i v-if="collapsible" class="chevron" :class="{ 'chevron--open': open }" aria-hidden="true">▾</i>
      </span>
    </component>

    <!-- A panel with no data states what it is waiting for and its current
         count -- never a 0.0% bar or an empty chart frame. -->
    <template v-if="open">
    <p v-if="waitingFor" class="py-6 text-center text-xs leading-relaxed text-slate-500">
      {{ waitingFor }}
    </p>
    <slot v-else />
    </template>
  </article>
</template>

<script>
export default {
  name: "ChartCard",
  props: {
    title: { type: String, default: "" },
    note: { type: String, default: "" },
    sample: { type: Number, default: null },
    pill: { type: String, default: "" },
    waitingFor: { type: String, default: "" },
    // Opt in to folding the card down to its header.
    collapsible: { type: Boolean, default: false },
  },
  data() {
    return { open: true };
  },
};
</script>

<style scoped>
.chart-card {
  border: 1px solid rgb(255 255 255 / 0.1);
  border-radius: 1rem;
  padding: 0.9rem;
  background: rgb(1 16 38 / 0.4);
  box-shadow: 0 12px 28px rgb(0 0 0 / 0.18);
}
.chart-head { width: 100%; text-align: left; }
.chart-head--toggle { cursor: pointer; }
.chevron { font-style: normal; color: #64748b; font-size: 0.7rem; transition: transform 150ms ease; }
.chevron--open { transform: rotate(180deg); }
.chart-title { color: white; font-size: 0.875rem; font-weight: 800; }
.chart-note { margin-top: 0.1rem; color: #64748b; font-size: 0.625rem; font-weight: 600; }
.sample-pill {
  flex: none;
  border-radius: 999px;
  background: rgb(255 255 255 / 0.05);
  padding: 0.25rem 0.5rem;
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 800;
}
</style>
